import PortfolioCategory from '@business/portfolio/PortfolioCategory';
import PortfolioItem from '@business/portfolio/PortfolioItem';
import PageTitle from '@components/common/PageTitle';
import { useAppStateSelector } from '@redux/hooks';
import { FunctionComponent } from 'react';
import PortfolioItemComponent from './PortfolioItemComponent';

interface PortfolioCategoryViewProps
{
    portfolioCategory: PortfolioCategory;
    portfolioItems: PortfolioItem[];
}

const PortfolioCategoryView: FunctionComponent<PortfolioCategoryViewProps> = (props) =>
{
    const language = useAppStateSelector(state => state.layout.language);
    const translation = props.portfolioCategory.getTranslation(language.code);

    /** Portfolio items */
    let cmpPortfolioItems = props.portfolioItems.map(portfolioItem =>
        <PortfolioItemComponent key={portfolioItem.id} portfolioItem={portfolioItem} />
    );
    
    /** Render */
    return (
        <div className="portfolio-category">
            <PageTitle title={props.portfolioCategory.getTranslation(language.code)!.title} />

            {cmpPortfolioItems}
        </div>
    );
}

export default PortfolioCategoryView;